<template>
    <div>
        <div class="content-box mr60">
            <p>当前素材为“已拒绝”是否继续通过</p>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 通过素材弹框-->
<script>

import API from '@/api/workOrder/conf.js';
export default {
    name: "resultModal",
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            console.log('submitModal');
        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style scoped>

</style>
